var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [(_vm.parentObj.action == 'create') ? _c('label', [_vm._v("Create Customer")]) : _vm._e(), _vm._v(" "), (_vm.parentObj.action == 'edit') ? _c('label', [_vm._v("Edit Customer")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Customer List"
    },
    on: {
      "click": _vm.showCustomerListing
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row mt-3"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Customer Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card-o' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerName),
      expression: "customerName"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "customerName",
      "id": "customerName",
      "placeholder": "Enter Customer Name"
    },
    domProps: {
      "value": (_vm.customerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.customerErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Consignee Code")]), (!_vm.disabled) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]) : _vm._e(), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card-o' style='font-size: 12px'></i>"
    }
  }, [(_vm.disabled) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consigneeCode1),
      expression: "consigneeCode1"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "disabled": _vm.disabled,
      "name": "consigneeCode1",
      "id": "consigneeCode1",
      "placeholder": "Enter Consignee Code"
    },
    domProps: {
      "value": (_vm.consigneeCode1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consigneeCode1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consigneeCode1),
      expression: "consigneeCode1"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "consigneeCode1",
      "id": "consigneeCode1",
      "placeholder": "Enter Consignee Code"
    },
    domProps: {
      "value": (_vm.consigneeCode1)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consigneeCode1 = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.consigneeErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Zip Code")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zipCode),
      expression: "zipCode"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "maxlength": 6,
      "pattern": "^(\\d{6})$",
      "name": "zipcode",
      "id": "zipcode",
      "placeholder": "Enter Zip Code"
    },
    domProps: {
      "value": (_vm.zipCode)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zipCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.zipcodeErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Channel")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card-o' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channel2),
      expression: "channel2"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "channel2",
      "id": "channel2",
      "placeholder": "Enter Channel"
    },
    domProps: {
      "value": (_vm.channel2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.channel2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ChannelErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-3"
  }, [_c('label', [_vm._v("City")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-building-o' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "city",
      "id": "city",
      "placeholder": "Enter City Name"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.cityErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-3"
  }, [_c('label', [_vm._v("State")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-building-o' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "state",
      "id": "state",
      "placeholder": "Enter State"
    },
    domProps: {
      "value": (_vm.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.stateErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-3"
  }, [_c('label', [_vm._v("Address")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-card' style='font-size: 12px'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "rows": 2,
      "type": "text",
      "name": "address",
      "id": "address",
      "placeholder": "Enter Address"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.addressErr))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "margin-left": "3rem",
      "margin-top": "1.5rem"
    }
  }, [(_vm.parentObj.action == 'create') ? _c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveData
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]) : _vm._e(), _vm._v(" "), (_vm.parentObj.action == 'edit') ? _c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateData
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" update")]) : _vm._e(), _vm._v("\n                     \n                  "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clearData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Clear")])])], 1)])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0178a9d1","hasScoped":true}!./src/modules/cargobooking/views/booking/abfrlLogs/abfrlcustomerdetails/abfrlcreatecustomer/abfrlCreateCustomer.component.html
// module id = 1258
// module chunks = 3